// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-5640636f] .noWrap {\n  white-space: nowrap;\n}\n[data-v-5640636f] .cap25 {\n  max-width: 25ch;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n[data-v-5640636f] .card {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n[data-v-5640636f] .card-body {\n  margin-bottom: -3.5rem;\n  padding-bottom: 0rem;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
